module.exports = __webpack_public_path__ + "static/media/1.3d7b4543.png";